import { Box, Button, Checkbox, Grid, TextField, Typography } from "@mui/material";
import RootComponents from "../../components/common/RootComponents"
import styles from './SearchCandidate.module.css';
import profile_image from "../../assets/images/ajit_image.jpeg";
import {customTextColor} from "../../utils/const";
import { useNavigate } from "react-router-dom";

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const PostRequestSubmit = () => {
    const navigate = useNavigate()
    return (
        // <RootComponents>
            <Box className={styles.search_candidate_stucture}>
                <Box className={styles.add_credit_section}>
                    <Box>
                        <Typography>AVAILABLE CREDIT</Typography>
                        <Typography sx={{ fontSize: '22px' }}>1250</Typography>
                        <Button>Add More Credit</Button>
                    </Box>
                    <img src={profile_image} alt="" />
                </Box>
                <Box className={styles.credit_deduct_cofirm}>
                    <Typography sx={{ color: customTextColor }}>50 Credit Deduct after confirmed by respective candidate</Typography>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: '7px 20px' }}>
                            <TextField id="standard-basic" label="Kevin Macklin" variant="standard" sx={{ width: '100%' }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: '7px 20px' }}>
                            <TextField id="standard-basic" label="Lead Java Developer" variant="standard" sx={{ width: '100%' }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: '7px 20px' }}>
                            <TextField id="standard-basic" label="Green Card" variant="standard" sx={{ width: '100%' }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: '7px 20px' }}>
                            <TextField id="standard-basic" label="Dallas Taxes" variant="standard" sx={{ width: '100%' }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: '7px 20px' }}>
                            <TextField id="standard-basic" label="Current Company" variant="standard" sx={{ width: '100%' }} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ padding: '7px 20px' }}>
                            <TextField id="standard-basic" label="Client Name" variant="standard" sx={{ width: '100%' }} />
                        </Grid>
                    </Grid>

                    <Box className={styles.request_submit_btns}>
                        <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#6c95c4', borderRadius: '5px', padding: '0px 20px' }}>
                            <Checkbox
                                {...label}
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }, marginRight: '5px' }}
                            />
                            <Typography sx={{ color: customTextColor, margin: '0 !important' }}>Request to Call</Typography>
                        </Box>
                        <Button sx={{ color: customTextColor }} onClick={() => navigate('/post-search-result')}>Request to Submit</Button>
                    </Box>

                </Box>

            </Box>
        // </RootComponents>
    )
}

export default PostRequestSubmit;